import type { ReactNode } from "react";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";
interface HeaderProps {
  children?: ReactNode;
  sticky?: boolean;
}

export const Header = ({ sticky, children }: HeaderProps) => (
  <div
    className={anchorClassNames("main__header", {
      "main__header--sticky": sticky,
    })}
  >
    {children}
  </div>
);
